module.exports = __webpack_public_path__ + "img/sankaku_10_red.5cdddf3b.png";